import packageJson from '../../package.json';

export const RELEASE_VERSION: string = packageJson.version;

export const VIEWPOINTS_IMAGE_PER_REQUEST = 10;
